<template>
  <div class="raceIntroduction">
    <div class="navbar-dark">
      <div class="container">
        <el-form
          ref="ruleForm"
          :rules="ruleRules"
          :model="form"
          :label-position="lablePosition"
          label-width="130px"
        >
          <!-- <el-form-item label="选择赛区" prop="divisionId">
            <el-select v-model="form.divisionId" placeholder="请选择赛区" @change="selectGet">
              <el-option
                v-for="item in divisions"
                :key="item.dictCode"
                :label="item.dictLabel"
                :value="item.dictCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择地区" prop="provinceId">
            <el-select
              v-model="form.provinceId"
              placeholder="省"
              @change="getArea(2, form.provinceId)"
              style="width: 32%"
            >
              <el-option
                v-for="item in provOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              v-model="form.cityId"
              placeholder="市"
              @change="getArea(3, form.cityId)"
              style="width: 32%"
            >
              <el-option
                v-for="item in cityOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select v-model="form.districtId" placeholder="县" @change="chanePlaceholder()" style="width: 33%">
              <el-option
                v-for="item in countyOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="下载模板">
              <el-button size="small" type="primary" :style="{'width':uploadStyle}" @click="downloadFile">点击下载</el-button><br/>
            <span @click="downloadFile" style="color: #ff0000;text-decoration: none;cursor: pointer;">操作前必看!点击下载模板，并按照模板提示进行填写，上传前请删除模板中的提示和样例数据。</span><br/>
          </el-form-item>
          <el-form-item label="上传信息">
              <el-upload
              class="upload-demo"
              :action="upExcel"
              :headers="headers"
              :on-success="handleSuccess">
              <el-button  size="small" type="primary" style="width: 100% !important;" >点击上传</el-button>
              <span slot="tip" class="el-upload__tip" style="padding-left:20px;">只能上传模板文件
<!--              <el-tooltip placement="bottom" effect="light">
              <div slot="content">
                <div style="font-size: 15px">
                  1、注意赛区填写完整，按照规范填写后缀（某某赛区）<br/><br/>
                  2、省市县不用填写"省、市、县"三个字，使用简称即可<br/><br/>
                  3、同一学校不同队伍名称不得重复<br/><br/>
                  4、<span style="color:red;font-weight: 600;">队长、队员电话填写本人电话(没有的话，可以填写家长的电话)，不允许填写指导老师的电话</span><br/><br/>
                  5、电话须填写手机号，不能填写座机<br/><br/>
                  6、队员信息为必填项，如参赛队伍只有一名选手，队员信息也需填入（重复填入队长信息即可）<br/><br/>
                  7、所有信息不用居中，不用手动调整样式<br/><br/>
                  8、如上述情况均填写完整，仍报错，可将完整信息下方10行左右的空白行删除，再保存后提交<br/><br/>
                </div>
              </div>
              <i class="el-icon-question" />
            </el-tooltip>-->
              </span>
            </el-upload>
<!--            <div>参赛项目类型为：创意作品-人机协作大学组；创意作品-未来校园中学组；科普实验-未来太空车</div>-->
            <a href="../static/doc/学校批量报名操作手册.pdf" style="text-decoration: none;" target="_blank">请点击查看具体操作方法</a>
<!--            <h5 style="color:red;font-weight: 600;">1.提交的报名信息中，队长的手机号码务必真实且准确，后续不可修改，该信息与作品评审和获奖联系有关。</h5>-->
<!--            <h5 style="color:red;font-weight: 600;">2.提交报名信息时，报名表中的成绩为非必填项。</h5>-->
<!--            <h5 style="color:red;font-weight: 600;text-indent: 10px;">（1）创意作品-人机协作大学组和创意作品-未来校园中学组的成绩由赛区组织初赛评审后确定。</h5>-->
<!--            <h5 style="color:red;font-weight: 600;text-indent: 10px;">（2）未来太空车的成绩，若在提交报名信息时，还没有成绩，报名表格中成绩项可空缺；待最终成绩确定后，重新上传和提交带有成绩的报名信息即可。</h5>-->
<!--            <h5 style="color:red;font-weight: 600;">3.注意：最终报名信息以最后上传提交的报名表格为准。若要增加参赛队伍，请在原有报名表格中增加报名信息，重新上传提交。</h5>-->
<!--            <h5 style="color:red;font-weight: 600;">4.团体报名中每一个参赛团队可用队长手机号登录大赛网站提交作品材料。</h5>-->
          </el-form-item>
          <el-form-item>
            <div v-if="start==0" v-text="msg"></div>
            <div v-else-if="start==1" >
              <ul v-html="upMsg"></ul>
            </div>
            <div v-else>
              <template>
                <el-table
                  :data="tableData"
                  style="width: 100%">
                  <el-table-column v-for="item in teamField" :key="item.index"
                    :prop="item.label_field"
                    :label="item.label_name"
                    width="180">
                    <!-- fix: 修复参赛项目显示1、2、3的问题 -->
                    <template slot-scope="scope" >
                        <span v-if="item.label_field === 'CompetitionProject'">
                          {{ projectObj[scope.row[item.label_field]] }}
                        </span>
                        <span v-else>{{ scope.row[item.label_field] }}</span>
                    </template>
                  </el-table-column>
<!--                  <el-table-column-->
<!--                    label="操作"-->
<!--                    width="120">-->
<!--                    <template slot-scope="scope">-->
<!--                      <el-button-->
<!--                        @click.native.prevent="deleteRow(scope.$index, tableData)"-->
<!--                        type="text"-->
<!--                        size="small">-->
<!--                        移除-->
<!--                      </el-button>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                </el-table>
              </template>
            </div>
          </el-form-item>

          <el-form-item style="text-align: center;" label-width="0px">
            <el-checkbox v-model="checked">我已阅读且同意</el-checkbox>
            <span
              @click="dataSourceVisible=!dataSourceVisible"
              style=" color: #409eff;cursor: pointer;"
            >《参赛须知》</span>
          </el-form-item>
          <el-form-item style="text-align: center;" label-width="0px">
            <el-button :disabled="disFlag" :key='1' type="primary" @click="onSubmit" :loading="showstyle"  :style="{'width':submitStyle}" >提交报名信息</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-dialog :visible.sync="dataSourceVisible" title="参赛须知" width="50%" v-if="content">
        <span v-html="content"></span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dataSourceVisible = false">取 消</el-button>
          <el-button type="primary" @click="dataSourceVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ChildLogo from '@/components/ChildLogo.vue'
import {getToken} from '@/utils/auth'
import {getField, compusSubmit, getparticipantDataByUserId} from '@/api/info/index'
import {getDivisions} from '@/api/system/index'
export default {
  components: {
    ChildLogo: ChildLogo
  },
  data () {
    return {
      projectObj: {
        1: '创意作品-人机协作（大学组）',
        3: '创意作品-科技改变生活（中学组）',
        2: '科普实验-未来太空车（中学组）'
      },
      disFlag: true,
      destroy: 0,
      upExcel: this.baseURL + '/participantData/signUp/upExcel/' + this.siteId + '/' + this.$store.state.user.userId,
      teamField: [],
      tableData: [],
      check: [],
      start: 0,
      msg: '无队伍信息，请导出模板，按模板填写信息后再导入',
      upMsg: '',
      fileList: [],
      form: {
        contParticipantMember: {},
        items: [{}],
        schoolSex: '0'
      },
      showstyle: false,
      dataSourceVisible: false,
      // provOptions: [], // 省下拉
      // cityOptions: [], //市
      // countyOptions: [], // 县
      // divisions: [], // 赛区
      // grounds: [], // 组别
      checked: false, // 是否已阅读
      content: '',
      ruleRules: {
        // divisionId: [
        //   { required: true, message: "请选择赛区", trigger: "change" }
        // ],
        // provinceId: [
        //   { required: true, message: "请选择地区", trigger: "change" }
        // ]
      },
      lablePosition: 'right',
      uploadStyle: '8.5% !important',
      submitStyle: '25'
    }
  },
  beforeMount () {
    // 添加判断方法
    let mobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    if (mobile) {
      this.lablePosition = 'top'
      this.uploadStyle = '25% !important'
      this.thissubmitStyle = '39% !important'
    }
  },
  created () {
    // 个人信息保密承诺书
    this.axios.get(this.siteURL + '/actuator/data/selectArticleDataList?siteId=' + this.siteId + '&nameEn=Confidentiality Commitment', {}).then(res => {
      if (res.data.code === 200) {
        this.content = res.data.data[0].content
      } else {
        this.$message(res.data.msg)
      }
    })
  },
  mounted () {
    // 获取省市县信息
    // this.getArea(1, null);
    // 获取赛区信息
    // this.getDivision();
    getField(this.baseURL, {siteId: this.siteId}).then(res => {
      this.teamField = res.data
    })
    // if (!this.$store.state.user) {
    //   this.$store.commit("competitionMutations", true);
    // } else {
    //   this.getSignUpByUser();
    // }
    this.getcheck()
  },
  computed: {
    headers () {
      return {
        'Authorization': 'Bearer ' + getToken()
      }
    }
  },
  methods: {
    chanePlaceholder () {
      this.$forceUpdate()
    },
    handleSuccess (response) {
      if (response.code === 500) {
        this.start = 1
        this.upMsg = response.msg
        this.tableData = []
      } else {
        this.start = 2
        this.disFlag = false
        this.tableData = response.data.table
        this.check = response.data.check
      }
    },
    downloadFile () {
      console.log('process.env:', process.env)
      let url = ''
      if (process.env.NODE_ENV === 'development') {
        url = '/static/doc/xiaoyuantemplate.xls'
      } else {
        url = 'https://kepudasai.cdstm.cn/static/doc/xiaoyuantemplate.xls'
      }
      const link = document.createElement('a')
      link.href = url
      link.style.display = 'none'
      link.download = `${'Samsung competition entry form'}.xls`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleExport () {
      const link = document.createElement('a')
      this.axios.get(this.baseURL + '/participantData/signUp/downLoad?siteId=' + this.siteId, {
        responseType: 'arraybuffer',
        xsrfHeaderName: 'Authorization',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + getToken()
        }
      }).then(res => {
        const blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel'
        })
        const objectUrl = URL.createObjectURL(blob)
        link.href = objectUrl
        link.download = 'Samsung competition entry form.xls' // 自定义文件名
        link.click() // 下载文件
        URL.revokeObjectURL(objectUrl)
      }).catch(err => {
        console.log(err)
      })
    },
    deleteRow (index, rows) {
      this.del += rows[index].userId + ','
      this.check.splice(index, 1)
      rows.splice(index, 1)
    },
    getArea (type, parentId) {
      var parentId = parentId != null ? '&parentId=' + parentId : ''
      var api =
        this.systemURL + '/actuator/area/list?levelType=' + type + parentId
      if (type === 1) {
        this.form.cityId = ''
      }
      this.axios.get(api, {}).then(res => {
        if (type === 1) {
          this.provOptions = res.data.rows
        } else if (type === 2) {
          this.cityOptions = res.data.rows
        } else if (type === 3) {
          this.countyOptions = res.data.rows
        }
      })
    },
    // 获取赛区信息
    getDivision () {
      getDivisions(this.systemURL).then(res => {
        this.divisions = res.data
      })
    },
    selectGet (vId) {
      let obj = this.divisions.find((item) => { // 数据源
        return item.dictCode === vId // 筛选出匹配数据
      })
      let string = obj.dictLabel.substring(0, obj.dictLabel.length - 2)
      for (let i = 0; i < this.provOptions.length; i++) {
        if (this.provOptions[i].name.substring(0, 2) === string) {
          this.form.provinceId = this.provOptions[i].id
          this.getArea(2, this.form.provinceId)
          this.form.cityId = undefined
          this.form.districtId = undefined
          break
        }
      }
    },
    replaceIdCardNum (str) {
      let arr = Array.from(str)
      arr[2] = '*'
      arr[3] = '*'
      arr[4] = '*'
      arr[5] = '*'
      arr[6] = '*'
      arr[7] = '*'
      arr[10] = '*'
      arr[11] = '*'
      arr[12] = '*'
      arr[13] = '*'
      return arr.join('')
    },
    onSubmit () {
      this.showstyle = true
      if (!this.checked) {
        this.showstyle = false
        this.$message('请阅读并同意《参赛须知》')
      } else {
        if (this.check.length === 0) {
          this.showstyle = false
          this.$message('请上传报名信息')
        } else {
          this.check.forEach(item => {
            if (item.idCord) {
              if (item.idCord !== '') {
                item.idCord = this.replaceIdCardNum(item.idCord)
              }
            }
            if (item.playerIdCord) {
              if (item.playerIdCord !== '') {
                item.playerIdCord = this.replaceIdCardNum(item.playerIdCord)
              }
            }
            if (item.player2IdCord) {
              if (item.player2IdCord !== '') {
                item.player2IdCord = this.replaceIdCardNum(item.player2IdCord)
              }
            }
            if (item.player3IdCord) {
              if (item.player3IdCord !== '') {
                item.player3IdCord = this.replaceIdCardNum(item.player3IdCord)
              }
            }
            if (item.player4IdCord) {
              if (item.player4IdCord !== '') {
                item.player4IdCord = this.replaceIdCardNum(item.player4IdCord)
              }
            }
            if (item.teacher1IdCard) {
              if (item.teacher1IdCard !== '') {
                item.teacher1IdCard = this.replaceIdCardNum(item.teacher1IdCard)
              }
            }
            if (item.teacher2IdCard) {
              if (item.teacher2IdCard !== '') {
                item.teacher2IdCard = this.replaceIdCardNum(item.teacher2IdCard)
              }
            }
          })
          compusSubmit(this.systemURL, {
            participantDatas: this.check,
            siteId: this.siteId,
            userId: this.$store.state.user.userId
          }).then(res => {
            if (res.code === 200) {
              this.disFlag = true
              this.showstyle = false
              this.checked = false
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              // this.$router.push({
              //   path: '/campusRegistration'
              // })
              // this.$router.go(0)
            } else {
              this.showstyle = false
              this.checked = false
              this.$message('请重新上传')
            }
          }).catch(() => {
            this.showstyle = false
            this.checked = false
            this.$message({
              message: '保存失败',
              type: 'error'
            })
          })
        }
      }
    },
    getcheck () {
      getparticipantDataByUserId(this.baseURL, {
        userId: this.$store.state.user.userId,
        siteId: this.siteId
      }).then(res => {
        if (res.data.table.length !== 0) {
          this.tableData = res.data.table
          this.check = res.data.check
          this.start = 2
          // this.getArea(2, res.data.table[0].provinceId)
          // this.getArea(3, res.data.table[0].cityId)
          // this.form = {
          //   divisionId:parseInt(res.data.select.divisionId, 10),
          //   provinceId:parseInt(res.data.select.provinceId, 10),
          //   cityId:parseInt(res.data.select.cityId, 10),
          //   districtId:parseInt(res.data.select.districtId, 10)
          // }
        } else {

        }
      })
    }
    // onSubmit() {
    //   this.$refs["ruleForm"].validate(valid => {
    //     if (valid) {
    //       if (!this.checked) {
    //         this.$message("请阅读并同意《个人信息保密承诺书》");
    //         return;
    //       }
    //       let userId = this.$store.state.user.userId;
    //       if (!userId) {
    //         this.$store.commit("loginVisibleMutations", true);
    //         return;
    //       }
    //       var api = this.baseURL+"/actuator/excel/upExcel/"+this.siteId;
    //       this.form.siteId = this.siteId;
    //       this.form.userId = userId;
    //       this.form.list = this.tableData;
    //       var params = this.form;
    //       this.axios
    //         .post(api, params)
    //         .then(res => {
    //           if (res.data.code == 200) {
    //             this.$message({
    //               message: "保存成功",
    //               type: "success"
    //             });
    //             this.$router.push({
    //               path: "/myHome",
    //               query: { articleId: "2" }
    //             });
    //             this.$router.go(0);
    //           } else {
    //             this.$message(res.data.msg);
    //           }
    //         })
    //         .catch(() => {
    //           this.$message({
    //             message: "保存失败",
    //             type: "error"
    //           });
    //         });
    //     }
    //   });
    // },
    // getSignUpByUser() {
    //   let userId = this.$store.state.user.userId;
    //   var api =
    //     this.baseURL +
    //     `/actuator/participant/list?userId=${userId}&siteId=${this.siteId}`;
    //   this.axios.get(api, {}).then(res => {
    //     if (res.data.rows.length == 1) {
    //       this.getArea(2, res.data.rows[0].provinceId);
    //       this.getArea(3, res.data.rows[0].cityId);
    //       this.form = res.data.rows[0];
    //     }
    //   });
    // },
  }
}
</script>

<style scoped>
.expertName {
  display: inline-block;
  text-align: left;
  width: 50%;
  color: #0654ef;
  font-size: 36px;
  padding-left: 20px;
}

.introduction {
  text-align: left;
  padding: 20px;
  text-indent: 2em;
}

.sigma-content {
  margin: 40px 0 10px;
  text-align: center;
  background-color: #fff;
}
.sigma-middle-line:before {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  background-color: #0654ef; /*颜色需与bai主题大背景du色一致zhi*/
  position: relative;
  top: 25px; /*调节线高*/
  left: 0;
}
.sigma-line-text {
  display: inline-block;
  background: #fff;
  padding: 0 18px 0 18px;
  position: relative;
  font-size: 28px;
  font-weight: 500;
  color: #0654ef;
}

.firstLevel {
  text-align: left;
  font-weight: bold;
}

.raceIntroduction .el-form-item__content > div {
  width: 100%;
}
/* .el-form-item__content .el-button--primary {
  width: 25% ;
} */
</style>



// WEBPACK FOOTER //
// src/components/CompusUpModule.vue